export default __webpack_public_path__ + "static/media/americanexpress.fe37d080.svg";